import React, { useEffect, useState } from "react";
import { AuthPaymentContainer } from "../../authenticated-payments/misc/auth-payment-container.component";
import { AuthContinue } from "../../authenticated-payments/misc/auth-continue.component";
import { Field, FieldArray, reduxForm, change } from "redux-form";
import { renderFieldArray, renderCheckboxField, renderSelectField } from "../../../utils/renderField";
import moment from "moment";
import Show from "../../../utils/show.component";
import { TravelExemptionDatePicker } from "./field-components/travel-exemption-date-picker.component";
import { CardControlsRestartButton } from "../misc/card-controls-restart-button.component";
import { select } from "redux-saga/effects";
import { travelExemptionToolTip } from "../../../utils/toolTips";
import ReactTooltip from "react-tooltip";
import { required } from "../../../utils/formValidators";

const TravelAbroadExemptionFormComponent = (props) => {
  // Set this in state so that it doesn't get reinitialized on every render
  const [now, setNow] = useState(new Date());
  
  const thisForm = props.thisForm;
  const values = thisForm && thisForm.values ? thisForm.values : {};
  const maxCountryCount = 15;

  const startDate = values.travelStartDate;
  const endDate = values.travelEndDate;

  const [formInitialized, setFormInitialized] = useState(false);
  const [exemptionReason, setExemptionReason] = useState("");
  const [isForeignPurchase, setIsForeignPurchase] = useState(false);
  
  const countriesSelectMap = props.countryOptions.map((country) => {
    return country.Name;
  });
  const memoizedRenderFieldArray = React.useCallback(
    renderFieldArray(
      countriesSelectMap,
      "Country",
      maxCountryCount,
      "Cannot add more than 15 countries."
    ),
    [props.countryOptions]
  );

  useEffect(() => {
    props.callGetCardOwners();
  }, []);

  useEffect(() => {
    if (props.selectedTravel != null && !formInitialized) {
      props.initialize({
        travelStartDate: moment(props.selectedTravel.StartDate).toDate(),
        travelEndDate: moment(props.selectedTravel.EndDate).toDate(),
        countries: props.selectedTravel.TravelExemptionCountries.map((e) => e.Name)
      });
      setFormInitialized(true);
    }
  }, [props.selectedTravel]);

  useEffect(() => {
    if (props.selectedTravel != null) {
      
    }
    else if ((props.travelReason != null && props.travelReason != "")) {
      setExemptionReason(props.travelReason);
      setIsForeignPurchase(props.travelReason === "ForeignPurchase");
    }
    else {
      props.showTravelReasonSelectionModal();
    }
  }, [props.travelReason]);

  const datesAreWithin180Days = () => {
    let isValid = false;

    if (startDate && endDate) {
      const startDateMoment = moment(startDate);
      const endDateMoment = moment(endDate);

      // Make sure start date is within 180 days of the end date
      isValid = endDateMoment.diff(startDateMoment, "days") <= 180;
    }

    return isValid;
  };

  const startIsBeforeEnd = () => {
    let isValid = false;

    if (startDate && endDate) {
      const startDateMoment = moment(startDate);
      const endDateMoment = moment(endDate);

      // Check that start date is before end date
      isValid = startDateMoment.isBefore(endDateMoment);
    }

    return isValid;
  };

  const show180DaysDateError = () => {
    return startDate && endDate && !datesAreWithin180Days();
  };

  const showStartBeforeEndDateError = () => {
    return startDate && endDate && !startIsBeforeEnd();
  };

  const disableSubmit = () => {
    return (
      props.submitting || !hasSelectedBorrower() || !datesAreWithin180Days() || !startIsBeforeEnd() || overMaxCountries()
    );
  };

  const submitFormCallback = () => {
    props.advanceToNextStep();
  };

  const submitForm = () => {
    window.scrollTo(0, 0);

    const borrowers = props.owners.filter((borrower) => {
      const values = props.thisForm.values;
      const borrowerIsSelected = values[`borrower_${borrower.interfaceId}`] ? true : false;
      return borrowerIsSelected;
    });

    const borrowerIds = borrowers.map((borrower) => borrower.interfaceId);

    let reason = "";
    let countriesArray = [];
    if (isForeignPurchase) {
      countriesArray = props.countryOptions.filter((country) => {
        return country.Name === props.thisForm.values.countryOfPurchase;
      });  
      reason = "Online Purchase";
    } else {
      countriesArray = props.countryOptions.filter((country) => {
        return props.thisForm.values.countries.includes(country.Name);
      });  
      reason = "Travel";
    }

    let exemptionNumber = null;
    if (props.selectedTravel) {
      exemptionNumber = props.selectedTravel.ExemptionNumber;
    }
    const dto = {
      exemptionNumber: exemptionNumber,
      reason,
      countriesArray,
      startDate: isForeignPurchase ? null : startDate,
      endDate: isForeignPurchase ? null : endDate,
      borrowerIds,
    };
    props.callSubmitTravelExemption(
      dto,
      submitFormCallback
    );
  };

  const hasSelectedBorrower = () => {
    const values = props.thisForm && props.thisForm.values ? props.thisForm.values : {};

    return props.owners.some((borrower) => {
      const borrowerIsSelected = values[`borrower_${borrower.interfaceId}`] ? true : false;

      return borrowerIsSelected;
    });
  };

  const overMaxCountries = () => {
    const countries = values.countries;
    if (countries) {
      let countryList = countries.filter((country) => {
        return country !== undefined && country !== null;
      });
      return countryList.length > maxCountryCount;
    }
    return false;
  };

  const borrowerInputArray = props.owners.map((borrower, index) => {
    let label = borrower.maskedCardNumber;
    if (borrower.cardholderName) {
      label = borrower.maskedCardNumber + '<br/>' + borrower.cardholderName;
    }
    return (
      <div className="row">
        <div className="col-12">
          <Field
            name={`borrower_${borrower.interfaceId}`}
            label={label}
            component={renderCheckboxField}
            type="checkbox"
            id={`borrower_${borrower.interfaceId}`}
          />
        </div>
      </div>
    );
  });

  useEffect(() => {
    if (props.owners && props.owners.length > 0) {
      let selectedCard = props.owners.filter(owner => owner.isSelected === true);
      if (selectedCard) {
        let selectedCardName = `borrower_${selectedCard[0].interfaceId}`;
        props.change(selectedCardName, true);
      }
    }
  }, [ props.owners ]);

  const countryLabel = (
    <div className="d-flex">
      <span>Select Country</span>
      <ReactTooltip effect="solid" type="light" />
      <i className="material-icons toolTip pl-3" data-tip={travelExemptionToolTip} data-html={true}>
        help
      </i>
    </div>
  );

  return (
      <AuthPaymentContainer title={isForeignPurchase ? "Foreign Purchase Details" : "Travel Exemption Details"}>
      <form onSubmit={props.handleSubmit(submitForm)} class="travel-exemption-form">
        <Show condition={!isForeignPurchase}>
          <h6 className="mt-3 f18 bold">When will you be traveling?</h6>
          <TravelExemptionDatePicker
            selected={values.travelStartDate}
            change={props.change}
            fieldName="travelStartDate"
            labelText="Start Date"
            minDate={now}
          />
          <TravelExemptionDatePicker
            selected={values.travelEndDate}
            change={props.change}
            fieldName="travelEndDate"
            labelText="End Date"
            minDate={now}
            wrapperClasses="mb-5"
          />
          <Show condition={show180DaysDateError()}>
            <div className="mt-3 error-message">
              Travel dates must be within 180 days of each other.
            </div>
          </Show>
          <Show condition={showStartBeforeEndDateError()}>
            <div className="mt-3 error-message">Start date must be before end date.</div>
          </Show>
        </Show>

        <Show condition={!isForeignPurchase}>
          <h6 className="mt-3">Where will you be traveling?</h6>
          <div className="mt-1">Make sure to include any countries you may have a layover in.</div>
          <div style={{ flexWrap: "nowrap" }}>
            <FieldArray name="countries" component={memoizedRenderFieldArray} />
          </div>
        </Show>

        <Show condition={isForeignPurchase}>
          <h6 className="mt-3 f18 bold">Where will your purchase be from?</h6>
          <div style={{ flexWrap: "nowrap" }}>
            <Field
              name="countryOfPurchase"
              label={countryLabel}
              component={renderSelectField}
              options={countriesSelectMap}
              validate={[required]}
            />
          </div>
        </Show>

        <h6 className="mt-3">{isForeignPurchase ? "Which card will be making the purchase?" : "Which card will be used while traveling?"}</h6>
        {borrowerInputArray}
        <AuthContinue title="Continue" type="submit" disabled={disableSubmit()} />
        <CardControlsRestartButton backToCards={props.backToCards} buttonText="Cancel" />
      </form>
    </AuthPaymentContainer>
  );
};

// Connect to Redux store
export const TravelAbroadExemptionForm = reduxForm({
  form: "TravelAbroadExemption",
  destroyOnUnmount: false,
  initialValues: {
    travelStartDate: moment().toDate(),
    travelEndDate: moment().add(1, "d").toDate(),
    countries: [""],
    borrowers: [""],
  },
})(TravelAbroadExemptionFormComponent);



// WEBPACK FOOTER //
// ./src/components/card-controls/forms/auth-travel-abroad-exemption-form.component.js